import EfTitle from '@elem/ui/ef-title';
import EfSpec from '@elem/ui/ef-spec';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import { useRouter } from 'next/router';

const icon = (
    <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" fill="none">
        <g clipPath="url(#clip0_1551_19139)">
            <path d="M2.93457 10.6147L6.98145 14.6616L16.2314 5.41162" stroke="white" strokeWidth="1.85" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <defs>
            <clipPath id="clip0_1551_19139">
                <rect width="18.5" height="18.5" fill="white" transform="translate(0.0439453 0.208496)" />
            </clipPath>
        </defs>
    </svg>
);

const tableIcons = [
    '',
    'https://websiteoss.ecoflow.com/upload/image/1735807470063/1.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638240426/2.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638240607/3.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638240211/4.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638240801/5.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638285951/6.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638286100/7.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638286288/8.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638286442/9.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638317392/10.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638317557/11.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638317766/12.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638317963/13.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638318165/14.svg',
];
const tableEuIcons = [
    '',
    'https://websiteoss.ecoflow.com/upload/image/1735807470063/1.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638240426/2.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638240607/3.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638240801/5.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638285951/6.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638286288/8.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638286442/9.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638317557/11.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638317963/13.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638318165/14.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638317766/12.svg',
    'https://websiteoss.ecoflow.com/upload/image/1744965294893/AI-Powered%20TOU%20Mode.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638240211/4.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638286100/7.svg',
    'https://websiteoss.ecoflow.com/upload/image/1744965295091/Power%20Prioritize.svg',
    'https://websiteoss.ecoflow.com/upload/image/1744965295281/Energy%20Report.svg',
    'https://websiteoss.ecoflow.com/upload/image/1735638318165/14.svg',
];

export default function TheComp() {
    const { t } = useLang('Oasis.Table');
    const { locale } = useRouter();
    const IS_NA_SITES = ['us', 'ca'].includes(locale ?? '');
    const tableList = IS_NA_SITES ? tableIcons : tableEuIcons;
    const list = IS_NA_SITES
        ? tableList.map((i, idx) => ({
              title: t(`item${idx + 1}.title`),
              shp2: t(`item${idx + 1}.shp2`),
              dpu: t(`item${idx + 1}.dpu`),
              dps: t(`item${idx + 1}.dps`),
              dp: t(`item${idx + 1}.dp`),
          }))
        : tableList.map((i, idx) => ({
              title: t(`item${idx + 1}.title`),
              shp2: t(`item${idx + 1}.shp2`),
              dpu: t(`item${idx + 1}.dpu`),
              dps: t(`item${idx + 1}.dps`),
              dp: t(`item${idx + 1}.dp`),
              RVs: t(`item${idx + 1}.RVs`),
          }));

    const getText = (text: string) => {
        switch (text) {
            case '1':
                return icon;
            case '0':
                return <span style={{ opacity: 0.6 }}>—</span>;
            default:
                return text;
        }
    };
    return (
        <div className={`${styles.TheComp}`} id="Table">
            <EfSpec />
            <EfTitle theme="white">{t('title')}</EfTitle>
            <div className="container">
                {list.map((i, idx) => (
                    <div className="items" key={idx}>
                        {Object.keys(i).map((j, idx2) => (
                            <div className="item" key={`${idx}-${idx2}`}>
                                {idx2 === 0 && <EfImg pc={tableList[idx]} />}
                                {getText(i[j as any])}
                            </div>
                        ))}
                    </div>
                ))}
            </div>
            {!IS_NA_SITES && <p className="tips">{t('tips')}</p>}
        </div>
    );
}
